import React, {forwardRef, useImperativeHandle, useState} from "react";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import SubmitButtonWarning from "../../UI/SubmitButtonWarning/SubmitButtonWarning";
import Timer from "../../UI/Timer/Timer";
import Form from "react-bootstrap/Form";
import {Lock} from "@material-ui/icons";
import Button from "react-bootstrap/Button";
import {Tooltip} from "@material-ui/core";
import {useSelector} from "react-redux";
import LibrarySelect from "../LibrarySelect/LibrarySelect";

const LibraryForm = forwardRef(({
    isMerging = false,
     isOpen, // Visibility control prop
     onEditComplete = () => {
     },
     onEditCancel = () => {
     }, // Default to no-op if not provided
     startingDesc = "", // Default starting description
     primaryFailMessage = "Action failed", // Default message for failure
     setShowPrimaryFailMessage = () => {
     }, // Default to no-op if not provided
     showPrimaryFailMessage = false, // Default fail message visibility
     enableTimer = false,
     rows = 3,
     startingSelect = [],
     useSelect = false,
    options = [],
    liveEdit = false,
}, ref) => {
    const [editDesc, setEditDesc] = useState(startingDesc);
    const [select, setSelect] = useState(startingSelect);
    const token = useSelector(state => state.auth.token)
    const userId = useSelector(state => state.auth.userId)

    useImperativeHandle(ref, () => ({
        getCurrentDesc: () => {
            return editDesc;
        },
        getCurrentSelect: () => {
            return select || [];
        }
    }));

    const handleEditSubmit = (event) => {
        event.preventDefault();
        onEditComplete(editDesc, select);
    };


    return (
        <div className={'secondary-popup'}><Form className="secondary-form" style={{marginBottom: 0}}
                                                 onSubmit={handleEditSubmit}>
            <Form.Group controlId="editDescription">
                <TextAreaWithTabs
                    rows={rows}
                    value={editDesc}
                    onChange={(e) => setEditDesc(e.target.value)}
                    required
                />
            </Form.Group>
            {useSelect && <Form.Group>
                <LibrarySelect select={select} options={options} onChange={(arr) => setSelect(arr)}/>
            </Form.Group>}
            <Button
                variant="danger"
                onClick={() => {
                    setEditDesc(startingDesc)
                    onEditCancel()
                }}
                className="preset-modal-cancel-button"
                style={{
                    color: 'white',
                    float: "right"
                }}
            >
                Cancel
            </Button>
            {!liveEdit && <SubmitButtonWarning
                token={token}
                userId={userId}
                handleSubmit={onEditComplete}
                failMessage={primaryFailMessage}
                setShowFailMessage={setShowPrimaryFailMessage}
                showFailMessage={showPrimaryFailMessage}
                postType={{
                    lowercase: "example games",
                    capital: "Example Game",
                    capitalLowercase: "Example games",
                }}
                submitButton={
                    <Button
                        variant="primary"
                        type="submit"
                        className="preset-modal-button-button"
                        style={{
                            float: 'right',
                            marginRight: '10px',
                        }}
                    >
                        {isMerging ? 'Update' : 'Submit'}
                    </Button>
                }
            />}
            {enableTimer && (
                <span style={{
                    color: "gray",
                    float: "right",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "20px",
                    marginTop: "6px"
                }}>
                            <Tooltip title="Example Locked for Editing" placement="top">
                                <Lock/>
                            </Tooltip>
                            <Timer
                                style={{marginBottom: 0, marginLeft: "5px"}}
                                hours={0}
                                minutes={59}
                                seconds={59}
                                onComplete={() => {
                                    setShowPrimaryFailMessage(true);
                                    // Additional failure modal handling if necessary
                                }}
                            />
                        </span>
            )}
        </Form></div>
    );
});

export default LibraryForm;
